import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import ShiftExchangeUser from 'pages/app/shifts/exchange/partials/ShiftExchangeUser'
import { ExecuteOperationOnPipe, useValue, WhenModelValue } from '@morningtrain/react-resources'
import ApproveShiftExchange from 'support/actions/shifts/ApproveShiftExchange'
import DeclineShiftExchange from 'support/actions/shifts/DeclineShiftExchange'

export default function ShiftExchangeEntryHeader ({
  onClick,
  withShiftSiblings = false,
  withActions = false
}) {
  const id = useValue('id')
  const exchangeType = useValue('exchange.type')
  const sellerScheduleId = useValue('exchange.seller_shift.schedule_id')
  const buyerScheduleId = useValue('exchange.buyer_shift.schedule_id')
  const shouldDisplayBuyerSiblingShifts = exchangeType === 'exchange' && sellerScheduleId !== buyerScheduleId

  return (
    <div className={'flex flex-col space-y-2 ' + (typeof onClick === 'function' ? 'cursor-pointer' : '')} onClick={onClick}>
      <UI.CardHeader>
        <UI.Text weight='medium' size='lg' block>
          <Displays.Enum name='exchange.type' enum='shift_exchange_type' />
        </UI.Text>
        {withActions && (
          <UI.ButtonWrap>
            <DeclineShiftExchange refreshPipes={<ExecuteOperationOnPipe resourceName='shifts.exchange' operationName='manageable' operationContext={{ context: 'smartview-single', id: id }} />} />
            <ApproveShiftExchange refreshPipes={<ExecuteOperationOnPipe resourceName='shifts.exchange' operationName='manageable' operationContext={{ context: 'smartview-single', id: id }} />} />
          </UI.ButtonWrap>
        )}
      </UI.CardHeader>
      {/*
      <UI.Text>
        <Displays.Enum name='exchange.status' enum='shift_exchange_status' />
      </UI.Text>
      */}
      <UI.SpaceBetween align='top'>
        <ShiftExchangeUser
          className='w-2/5'
          namePrefix='exchange.seller'
          withShiftSiblings={withShiftSiblings}
        />
        <div className='w-6 h-6 mr-16 mt-10'>
          <WhenModelValue name='exchange.type' condition='exchange'>
            <UI.Icons.Exchange />
          </WhenModelValue>
          <WhenModelValue name='exchange.type' condition='exchange' negate>
            <UI.Icons.ArrowRight />
          </WhenModelValue>
        </div>
        <ShiftExchangeUser
          className='w-2/5'
          namePrefix='exchange.buyer'
          withShiftSiblings={shouldDisplayBuyerSiblingShifts}
        />
      </UI.SpaceBetween>
    </div>
  )
}
